module.exports = __webpack_public_path__ + "nuevotramite.png?ea89c9e46b0659f3f14089bfdd5ca484";


//////////////////
// WEBPACK FOOTER
// ./src/assets/nuevotramite.png
// module id = 685
// module chunks = 0 2 7 8 9 10